import { Component } from '@angular/core';

@Component({
  selector: 'app-section-fale-conosco',
  templateUrl: './section-fale-conosco.component.html',
  styleUrls: ['./section-fale-conosco.component.scss'],
})
export class SectionFaleConoscoComponent {
  contatos: any[] = [
    {
      href: 'mailto:fundacao@educere.org.br',
      icon: 'far fa-envelope',
      text: 'fundacao@educere.org.br',
      class: 'icone',
    },
    {
      href: 'https://wa.me/554484052037',
      icon: 'fab fa-whatsapp',
      text: '(44) 98405-2037',
      class: 'icone',
    },
    {
      href: 'https://linktr.ee/fundacaoeducere',
      icon: 'fa-solid fa-tree',
      text: 'Linktree',
      class: 'icone',
    }
    // {
    //   href: 'https://www.facebook.com/fundacaoeducere',
    //   icon: 'fab fa-facebook',
    //   text: 'Facebook',
    //   class: 'icone',
    // },
  ];
}
